import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();

  console.log('🧭 Navigation RENDER oldu! Path:', location.pathname);

  const navStyle = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
    borderTop: '1px solid #e0e0e0',
    padding: '0.5rem 0',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    zIndex: 1000
  };

  const navItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#666',
    padding: '0.5rem',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    flex: 1,
    maxWidth: '100px'
  };

  const activeNavItemStyle = {
    ...navItemStyle,
    backgroundColor: '#1976d2',
    color: 'white'
  };

  const handleNavClick = (pageName) => {
    console.log('🧭 Navigation tıklandı:', pageName, new Date().toLocaleTimeString());
  };

  return (
    <nav style={navStyle}>
      <Link
        to="/"
        style={location.pathname === '/' ? activeNavItemStyle : navItemStyle}
        onClick={() => handleNavClick('Dashboard')}
      >
        <span style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}>📊</span>
        <span style={{ fontSize: '0.75rem' }}>Dashboard</span>
      </Link>

      <Link
        to="/sync"
        style={location.pathname === '/sync' ? activeNavItemStyle : navItemStyle}
        onClick={() => handleNavClick('Sync')}
      >
        <span style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}>🔄</span>
        <span style={{ fontSize: '0.75rem' }}>Sync</span>
      </Link>

      <Link
        to="/products"
        style={location.pathname === '/products' ? activeNavItemStyle : navItemStyle}
        onClick={() => handleNavClick('Products')}
      >
        <span style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}>🔍</span>
        <span style={{ fontSize: '0.75rem' }}>Ürünler</span>
      </Link>

      <Link
        to="/users"
        style={location.pathname === '/users' ? activeNavItemStyle : navItemStyle}
        onClick={() => handleNavClick('Users')}
      >
        <span style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}>👥</span>
        <span style={{ fontSize: '0.75rem' }}>Kullanıcılar</span>
      </Link>

      {/* 🔥 YENİ: ORDERS BUTONU - AYARLARIN YERİNE */}
      <Link
        to="/orders"
        style={location.pathname === '/orders' ? activeNavItemStyle : navItemStyle}
        onClick={() => handleNavClick('Orders')}
      >
        <span style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}>📦</span>
        <span style={{ fontSize: '0.75rem' }}>Orders</span>
      </Link>

      <Link
        to="/price-management"
        style={location.pathname === '/price-management' ? activeNavItemStyle : navItemStyle}
        onClick={() => handleNavClick('Price Management')}
      >
        <span style={{ fontSize: '1.5rem', marginBottom: '0.25rem' }}>⚙️</span>
        <span style={{ fontSize: '0.75rem' }}>Price Management</span>
      </Link>





    </nav>
  );
};

export default Navigation;